<template>
  <div class="flyingBook">
    <img v-if="type === 1" src="../../assets/images/failed@2x.png" alt="" />
    <img v-else src="../../assets/images/loading.gif" style="width: 50px" alt="" />
    <div v-if="type === 1">登录失败 请稍后重试</div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';

import api from '@/api';
import { post } from '@/utils/http';
import { getLogo } from '@/utils/intConfiguration';
import {
  setAccount,
  setUserSys,
  setUserZnEnv,
  setToken,
  // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';
import { getUiFitment } from '@/utils/accessResources';

const { envList } = require('../../../config/dev.proxy');

export default {
  components: {},
  data() {
    return {
      logoUi: getLogo(),
      args: this.getQueryStringSource(),
      type: 0, // 0-加载中 1-失败
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.flyingBookLogin();
  },
  methods: {
    // TODO线上缓存 （适配apaas+告警sdk apaas调整结构，统一网络库后 废弃）
    initenv() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      function prdZnv() {
        // eslint-disable-next-line no-unused-vars
        let isProduct = true;
        envList.forEach((m) => {
          if (window.location.hostname.toString().includes(m)) {
            isProduct = false;
            setUserZnEnv(m);
            setUserSys(_this.logoUi.appId);
          }
        });
        if (isProduct) {
          setUserZnEnv('product');
          // 本地ng转发后 appId未定义问题
          // eslint-disable-next-line no-underscore-dangle
          const _host = window.location.hostname.toString();
          if (!_host.includes('192') && !_host.includes('localhost')) {
            setUserSys(_this.logoUi.appId);
          }
        }
      }
      if (process.env.NODE_ENV !== 'development') {
        prdZnv();
      }
    },
    flyingBookLogin() {
      post(api.flyingBookLogin, {
        code: this.args.code,
        state: this.args.state,
      }).then((res) => {
        setToken(res);
        this.getLoginAccount(res);
      });
    },
    // 获取用户信息
    getLoginAccount(loginRes) {
      this.initenv();
      // debugger;
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
        this.type = 1;
      })
        .then((res) => {
          // 之后缓存菜单需要参数
          setAccount(res, loginRes);
          getUiFitment().finally(()=>{
            if (res.id) {
            this.$store.commit('emptyTab');
            this.toProcessPage();
          } else {
            this.type = 1;
          }
           })
        });
    },
    // 跳转指定页面
    toProcessPage() {
      try {
        // eslint-disable-next-line camelcase, prefer-destructuring
        // approval存在 增加fromObjectLayoutApiKey ='todoList'
        const params = this.getQueryStringSource(this.args.path.split('?')[1]);
        // id存在 就增加data
        // eslint-disable-next-line camelcase
        const url_data = {
          apiKey: params.layoutApiKey,
          id: this.args.id,
        };
        // eslint-disable-next-line no-unused-expressions
        this.args.id ? params.data = encodeURIComponent(JSON.stringify(url_data)) : null;
        // eslint-disable-next-line no-unused-expressions
        this.args.approval ? params.fromObjectLayoutApiKey = 'todoList' : null;
        // eslint-disable-next-line no-unused-expressions
        this.args.taskId ? params.fromObjectTaskId = this.args.taskId : null;
        const firstPath = this.args.path.split('?')[0].charAt(0);
        this.$router.push({
          path: `${firstPath !== '/' ? '/' : ''}${this.args.path.split('?')[0]}`,
          query: params,
        });
      } catch (error) {
        this.type = 1;
      }
    },
    getQueryStringSource(url) {
      // eslint-disable-next-line no-restricted-globals
      let qs = '';
      if (!url) {
        qs = window.location.search.length > 0 ? window.location.search.substring(1) : '';
      } else {
        qs = url;
      }
      // eslint-disable-next-line prefer-const
      let args = {};
      // eslint-disable-next-line prefer-const
      let items = qs.length ? qs.split('&') : [];
      let item = null;
      let name = null;
      let value = null;
      let i = 0;
      const len = items.length;
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < len; i++) {
        item = items[i].split('=');
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
  },
};
</script>

<style lang="less" scoped>
.flyingBook {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // height: 100%;
  width: 400px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -60%, 0);

  img {
    display: block;
  }

  div {
    // position: absolute;
    text-align: center;
    font-size: 22px;
    margin-top: 16px;
  }
}
</style>
